export class Partenaire {
  id: number;
  name: string;
  email: string;
  description: string;
  is_active: boolean;
}
